import axios from 'axios';
import { useState, useEffect, useCallback } from 'react';
import { apiConstant } from './constant';
import useDebounce from '../../../../hooks/useDebounce';
import { useQuery } from '../../../../hooks/UseQuery';

const useGetData = () => {
  const [racksData, setRacksData] = useState<any>([]);
  const [compartmentData, setCompartmentData] = useState<any>([]);
  const [isLoading, setIsLoading] = useState(false);
  const [useEffectRender, setUseEffectRender] = useState(false);
  const [tabValue, setTabValue] = useState<number>(0);
  const [rackId, setRackId] = useState(null);
  const search = useQuery('search') || '';

  useEffect(() => {
    setIsLoading(true);
    axios
      .get(`/api/${apiConstant.rackroute}`)
      .then((res) => {
        if (res.data) {
          if (res.data.length > 0) setRackId(res?.data?.[0]?._id || null);
          setRacksData(res.data);
          setIsLoading(false);
        }
      })
      .catch((err) => {
        setIsLoading(false);
      });
  }, [useEffectRender]);

  const fetchData = async () => {
    if (!rackId) return;
    setIsLoading(true);
    axios
      .get(
        `/api/${apiConstant.compartmentroute}?rackId=${rackId}&search=${search}`
      )
      .then((res) => {
        if (res.data) {
          setCompartmentData(res.data.results);
          setIsLoading(false);
        }
      })
      .catch((err) => {
        setIsLoading(false);
      });
  };

  useEffect(() => {
    setRackId(racksData?.[tabValue]?._id);
  }, [tabValue]);

  const handleCompartmentData = useCallback(
    (rowIndex: number | null, key: string, newValues: any) => {
      setCompartmentData((prev: any) => {
        const upadateCompartment: any = [...prev];
        if (rowIndex === null) return;
        const updatedRow = upadateCompartment?.[rowIndex];
        updatedRow[key] = newValues;
        upadateCompartment[rowIndex] = updatedRow;
        return upadateCompartment;
      });
    },
    []
  );

  const addCompartment = useCallback(() => {
    setCompartmentData((prev: any) => {
      return [
        ...prev,
        {
          name: '',
          parts: null,
          isLocked: false,
          rack_id: rackId || null,
          _tempId: `temp-id-${new Date().getTime()}`,
        },
      ];
    });
  }, [rackId]);

  useDebounce(fetchData, 500, [search, rackId]);

  return {
    rackId,
    racksData,
    setRacksData,
    isLoading,
    setUseEffectRender,
    compartmentData,
    handleCompartmentData,
    tabValue,
    setTabValue,
    addCompartment,
  };
};

export default useGetData;
